import FF from "@/components/forms/FormField.module.css";

import { WButton, type WButtonProps } from "@/components/button/WButton.tsx";
import type { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import type { SetOptional } from "type-fest";

export function FormActions({ children }: { children: ReactNode }) {
    return <div className={FF.FormActions}>{children}</div>;
}

/** Like `WButtonProps`, but without a required `action`: submit buttons trigger the surrounding form instead. */
export type FormSubmitButtonProps = SetOptional<WButtonProps, "action">;

/** A submit button that binds loading state to the surrounding react-hook-form context. */
export function FormSubmitButton(props: FormSubmitButtonProps) {
    const {
        formState: { isLoading, isSubmitting },
    } = useFormContext();
    return (
        <WButton type="submit" color="primary" action={undefined} isLoading={isLoading || isSubmitting} {...props} />
    );
}
